import {Injectable, OnInit} from "@angular/core";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs/Observable";
import {BusService, INewDocumentEvent} from "./bus.service";

@Injectable()
export class WatchService {
  private _hasChanges: boolean = false;
  private bypassChangeEvent: boolean = false;
  private docChangedSubject: BehaviorSubject<boolean> = new BehaviorSubject(null);


  constructor(private busService:BusService) {
    this.busService.onDocumentUpdated
      .subscribe(e => this.onDocumentUpdated(e));
  }


  public docChanged(): Observable<boolean> {
    return this.docChangedSubject.asObservable();
  }


  public get hasChanges(): boolean {
    return this._hasChanges;
  }


  public notify() {
    if (this.bypassChangeEvent) {
      console.log('notify doc changed');
      this.docChangedSubject.next(this._hasChanges = true);
    }
  }


  public reset() {
    console.log('reset doc changed');
    this.docChangedSubject.next(this._hasChanges = false);
  }

  private onDocumentUpdated(e: INewDocumentEvent) {
    this.bypassChangeEvent = e.document && !e.readonly;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/watch.service.ts